import { useGetCompanyQuery } from "@/api/AppApi/services/company";

const useCanTabby = () => {
  const { data } = useGetCompanyQuery();
  return data?.result.preferences?.tabby_integration;
};

export default useCanTabby;
